import React from 'react';
import { withRouter } from 'react-router-dom';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import './style.scss';

const ProductBanner = props => {
  const { height, isMobile } = useViewport();
  const { productDetails, path, web, mobile, thumbnail } = props.data.data;
  const { type } = props.data;

  let details = '';

  productDetails.map(data => {
    details = data;
  });
  const product_name = details.product_name;
  const productVersion = details.productVersion;
  const min_area = details.min_area;
  const max_area = details.max_area;
  let image = details && `${path}${web}/${details.image}`;
  let thumbNail = details && `${path}${thumbnail}/${details.image}`;
  let countLengthOf = StringUtil.sliceHtml(details.long_content);
  const length = words(countLengthOf).length;
  let lengthOf = StringUtil.sliceHtml(details.short_content);
  const count = words(lengthOf).length;
  const description_mobile = StringUtil.sliceHtml(details.description_mobile);

  let classNames = 'product-details-banner';
  if (isMobile) {
    image = details && `${path}${mobile}/${details.mobile_image}`;
    thumbNail = details && `${path}${thumbnail}/${details.mobile_image}`;
  }

  const animationClasses = ['animate-height', 'animate-width'];

  const renderHeading = () => {
    if (type == 'Workcations') {
      return null;
    }
    return (
      <HTMLView
        className={'product-description-heading'}
        html={details.short_content}
        tagName={'p'}
      />
    );
  };

  const renderDescription = () => {
    return (
      <HTMLView
        className={'product-details-description'}
        html={details.long_content}
        tagName={'p'}
      />
    );
  };

  const renderProductArea = () => {
    if (min_area && max_area) {
      return (
        <div className={'product-area'}>
          <span className={'m-unit'}>SQ.FEET</span>
          <h2 className={'area'}>
            {min_area}&nbsp;-&nbsp;{max_area}
          </h2>
        </div>
      );
    } else if ((min_area && !max_area) || (max_area && !min_area)) {
      let display_area =
        min_area && !max_area
          ? min_area
          : max_area && !min_area
          ? max_area
          : '';
      return (
        <div className={'product-area'}>
          <span className={'m-unit'}>SQ.FEET</span>
          <h2 className={'area'}>{display_area}</h2>
        </div>
      );
    } else return <></>;
  };

  return (
    <div className={classNames} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'product-intro'}
        imageUrl={image}
        thumbNailUrl={thumbNail}
        length={length}
        headingLength={count}
        descriptionClass={'product-description'}
        descriptionHeading={renderHeading()}
        description={renderDescription()}
        bannerImage={animationClasses.join(' ')}
        altImageName={product_name}
      />
      <div className={'short-description'}>{description_mobile}</div>
      {type !== 'Workcations' && ( 
        <div className={'title'}>
          <span>Product Model</span>
        </div>
      )}
      <div className={'product-title'}>
        <div className={'product-full-name'}>
          <span className={type=="Workcations"? "product-name workation-name" : "product-name"}>{product_name}</span>
          <span className={'product-version'}>{productVersion}</span>
        </div>
        {renderProductArea()}
      </div>
      {details.banner_video && (
        <BannerVideoButton videoUrl={details.banner_video} />
      )}
      {/*<FooterExploreButton onClick={handleClick} theme={theme} />*/}
    </div>
  );
};

export default withRouter(ProductBanner);
